import Api from "../axios"

export const getViewMessageLeave=({id})=>{
    return Api.get(`/view_message_leave?application_id=${id}`)
}